import { AxiosInstance } from "axios"
import { MerchantSatellites } from "./satellitesTypes"

export enum SupplierSatellitesQuery {
    SATELLITES_LIST = "satellites-for-supplier",
}

type SatellitesTypesForSupplierParams = Readonly<{
    supplierId: number
    merchantIds?: string
}>

export type SatellitesTypesForSupplierResponse = Readonly<{
    merchants: Array<MerchantSatellites>
}>

export async function fetchSatellitesForSupplierParams(
    params: SatellitesTypesForSupplierParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SatellitesTypesForSupplierResponse> {
    const { supplierId, ...rest } = params
    const url = `/suppliers/${supplierId}/satellites`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
